import { API as SalesDemoRegistryAPI } from '@weave/schema-gen-ts/dist/apis/api/salesdemo/v1/registry/api.pb';
import { API as SalesDemoSandboxesAPI } from '@weave/schema-gen-ts/dist/apis/api/salesdemo/v1/sandboxes/api.pb';
import { bindHTTPApis } from '@frontend/schema';
import type {
  ListSandboxesResponse,
  Sandbox,
  ListRegistrationsResponse,
  Registration,
} from '../types/sales-demo.types';

// salesdemo APIs are `group: apis` and only consumed here, so bind them locally
// rather than adding to the central @frontend/schema service barrel.
const SchemaSalesDemoSandboxesService = bindHTTPApis(SalesDemoSandboxesAPI);
const SchemaSalesDemoRegistryService = bindHTTPApis(SalesDemoRegistryAPI);

export const listSandboxes = (req: { pageSize?: number; pageToken?: string; filter?: string }) =>
  SchemaSalesDemoSandboxesService.ListSandboxes(req) as Promise<ListSandboxesResponse>;

export const getSandbox = (sandboxId: string) =>
  SchemaSalesDemoSandboxesService.GetSandbox({ sandboxId }) as Promise<Sandbox>;

export const listRegistrations = (req: { pageSize?: number; pageToken?: string; filter?: string }) =>
  SchemaSalesDemoRegistryService.ListRegistrations(req) as Promise<ListRegistrationsResponse>;

export const getRegistration = (registrationId: string) =>
  SchemaSalesDemoRegistryService.GetRegistration({ registrationId }) as Promise<Registration>;
